import { Configuration } from '@azure/msal-browser'

export const msalConfig: Configuration = {
  auth: {
    clientId: import.meta.env.VITE_AZURE_AD_CLIENT_ID || 'your-client-id',
    authority: `https://login.microsoftonline.com/${import.meta.env.VITE_AZURE_AD_TENANT_ID || 'your-tenant-id'}`,
    redirectUri: import.meta.env.VITE_AZURE_AD_REDIRECT_URI || `${window.location.origin}/auth/callback`,
    postLogoutRedirectUri: window.location.origin,
    navigateToLoginRequestUrl: false,
  },
  cache: {
    // localStorage (not sessionStorage): the MSAL account cache must survive
    // new tabs / browser restarts. With sessionStorage, reopening the app left
    // our derived `access_token` (localStorage) STALE while MSAL had no account
    // to renew it with — every request 401'd, the refresh path logged "No MSAL
    // accounts available", and the session-expired modal could never recover
    // because reloading reproduced the exact same state. The id token already
    // lives in localStorage, so this adds no new storage exposure class.
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  }
}

// Interactive login request - used for initial login
export const loginRequest = {
  scopes: ['openid', 'profile', 'email'],
  prompt: 'select_account', // Force account selection for interactive login
}

// Boot-time auto-login — deliberately NO prompt: when the session expires
// before the app has done anything (page reopened with an unrenewable token),
// we redirect straight to Entra and let the SSO cookie complete the round-trip
// with zero clicks. Entra only shows credential UI when it truly has no session.
export const autoLoginRequest = {
  scopes: ['openid', 'profile', 'email'],
}

// Silent token request - used for background token refresh
export const silentRequest = {
  scopes: ['openid', 'profile', 'email'],
  // NO prompt parameter - this is for silent acquisition only
}
